// extracted by mini-css-extract-plugin
module.exports = {"header":"SkewHeader-module--header--3AHF5","content":"SkewHeader-module--content--3V_O_"};